import React, { useContext, useEffect, useRef } from 'react'
import { useClickAway, useKeyPress } from 'react-use'
import styled from 'styled-components'
import { colors } from '@giphy/react-giphy-brand'
import { googleAnalyticsEvent } from 'shared/util/analytics'
import { Modal } from '../modal'
import download from 'downloadjs'
import DashboardUserContext from '../../../site/dashboard/context'
import { request } from '../../api'
import AnimatedDownloadButton from './animated-download-button'


const Container = styled.div`
    position: absolute;
    top: 170px;
    left: 50%;
    width: 620px;
    height: auto;
    padding: 55px;
    transform: translateX(-50%);
    background-color: ${colors.giphyDarkestGrey};

    & p {
        text-align: center;
        font-size: 18px;
        font-weight: 700;
        margin: 0;
        line-height: 25px;
    }
`

const Links = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 35px;
`

const DisclaimerContainer = styled.div`
    color: ${colors.giphyLightGrey};
    margin-top: 35px;
    flex-direction: column;
    text-align: center;
`

type Props = {
    csv: string
    csvCtr: string
    onClose: () => void
}

const CsvModal = ({ csv, csvCtr, onClose }: Props) => {
    const [isEscPressed] = useKeyPress((event: KeyboardEvent) => event.keyCode === 27)
    const { user } = useContext(DashboardUserContext)

    useEffect(() => {
        if (isEscPressed) {
            onClose()
        }
    }, [isEscPressed])
    const ref = useRef(null)
    useClickAway(ref, () => {
        onClose()
    })

    const downloadCSV = async (csvUrl, label) => {
        const response = await request(
            csvUrl,
            {
                headers: {},
                credentials: 'omit',
            },
            user.token,
            false
        )
        const fileName = response.headers.get('content-disposition').split('"')[1]
        download(await response.blob(), fileName, 'text/csv')

        googleAnalyticsEvent({
            category: 'Dashboard',
            action: 'CSV Download',
            label: label,
        })
    }

    return (
        <Modal>
            <Container ref={ref}>
                <p>
                    {`Select the data you'd like to download for your ${csvCtr ? 'GIFs' : 'Clips'}.`}
                    {csvCtr && `Engagement Rate on GIPHY shows the percentage of times a user engages with your GIFs in search!`}
                </p>
                <Links>
                    <AnimatedDownloadButton
                        title={csvCtr ? 'View Count CSV' : 'Impression Count CSV'}
                        clickCallback={() => downloadCSV(csv, 'Views')}
                    />
                    {csvCtr && (
                        <AnimatedDownloadButton
                            title={'Engagement Rate CSV'}
                            clickCallback={() => downloadCSV(csvCtr, 'Engagement Rate')}
                        />
                    )}
                </Links>
                <DisclaimerContainer>
                    Processing large CSV’s can take a bit. Please be patient!
                </DisclaimerContainer>
            </Container>
        </Modal>
    )
}

export default CsvModal
